/* @flow strict */

/* eslint-disable camelcase */
/* eslint-disable react/jsx-handler-names */
/* eslint-disable complexity */

import * as React from 'react';
import { withRouter } from 'react-router-dom';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import moment from 'moment-timezone/builds/moment-timezone-with-data';
import { timezonesList } from '/client/src/oldSrc/jstz';
import { POST, PUT } from '/client/src/api/';
import _ from 'lodash';
import { defaultLevelObj } from './levels/defaultLevelObj';
import CssPinner from '/client/src/components/csspinner';
import NProgressCustom from '/client/src/components/nProgress';
import validateTicketLevels from './validator/ticketLevels';
import validateQuestionLevels from './validator/questionLevels';
import validateFbInfo from './validator/fbinfo';
import validateDonations from './validator/donations';
import validateConfirmEmail from './validator/confirmationEmail';
import { ToggleLeftMenu } from '/client/src/utils/animation';
import type { CreateEditStateType, CreateEditContextType, CreateEditPropsType } from './types';
import validateTicketMainInfo from './validator/mainInfo';
import { DefaultContainerContext } from '/client/src/contexts/defaultContainer';
import { getWindowsTzId, convertToLocalTime, convertToUTC } from '/client/src/utils/jstz';
import { convertTextLinksToTargetBlank } from '/client/src/utils/string';
import { GetErrorValidation } from '../../../../utils/errorMessageValidation';

const WithEventContext = (WrappedComponent: any): any => {
  class WithEventContextClass extends React.Component<null, CreateEditStateType> {
    state: CreateEditStateType;

    static contextType = EventDetailContainerContext;

    constructor(props: CreateEditPropsType, context: CreateEditContextType) {
      super(props, context);

      this.urlNamePrefix = process.env.EVENT_HOST;
      this.isNew = this.props.match.url === '/events/new';

      this.state = { ...this.initEventData() };
    }

    initEventData = (): any => {
      let { eventDetail } = this.context;

      if (!eventDetail) {
        eventDetail = {};
      }

      const browserTimeZone = moment.tz.guess();

      const getEventDetailAdvSetStatus = (): boolean => {
        return _.get(eventDetail, 'skip_event_landing_page', false) ||
          !_.get(eventDetail, 'show_event_time_and_date', true) ||
          _.get(eventDetail, 'show_promotion_tickets', false) ||
          !_.get(eventDetail, 'show_tickets', true) ||
          !_.get(eventDetail, 'show_ticket_sales_time_count_down', true) ||
          _.get(eventDetail, 'show_remaining_ticket_count', false) ||
          !_.get(eventDetail, 'skip_collect_attendee_information', true) ||
          !_.get(eventDetail, 'need_collect_zip_code', true) ||
          !_.get(eventDetail, 'need_collect_phone_number', true) ||
          _.get(eventDetail, 'is_set_tickets_total_capacity', false);
      };

      const tickets = _.map(eventDetail.tickets, (t: {}): {} => {
        t.price = t.price; // eslint-disable-line
        t.temp_id = t.id; // eslint-disable-line
        return t;
      });

      return {
        invalidInputsLength: [],
        successSave: false,
        lat: eventDetail.lat || 39,
        lng: eventDetail.lng || 259,
        map_zoom: eventDetail.map_zoom || 3,
        name: eventDetail.name || ' ',
        // eslint-disable-next-line
        url_name: eventDetail && eventDetail.url_name ? `${this.urlNamePrefix}${eventDetail.url_name}` : `${this.urlNamePrefix}`,
        suggestions: [],
        discounts: _.map(eventDetail.discounts || [], (d: {}): [] => {
          return {
            ...d,
            applied_to_ticket_temp_id: d.applied_to_ticket_id
          };
        }),
        donations: !!_.size(eventDetail.donations) ? eventDetail.donations : [],
        is_set_discounts: eventDetail.is_set_discounts || false,
        is_set_donations: eventDetail.is_set_donations || false,
        long_description: eventDetail.long_description || '',
        short_description: eventDetail.short_description || '',
        // eslint-disable-next-line
        autoCompleteValue: eventDetail.location ? { formatted_address: eventDetail.location } : { formatted_address: '' },
        begin_time_utc: convertToLocalTime(eventDetail.begin_time_utc || moment(), eventDetail.time_zone_id),
        end_time_utc: convertToLocalTime(eventDetail.end_time_utc || moment(), eventDetail.time_zone_id),
        schedules: eventDetail.schedules || [],
        time_zone_id: eventDetail.time_zone_id || timezonesList[_.toLower(browserTimeZone)],
        openedCropModal: false,
        imgUrl: eventDetail.image_url || '',
        baseImage: {
          file: null,
          image: eventDetail.image_url || null
        },
        croppedImage: {
          file: null,
          image: null // image: eventDetail.image_url || null
        },
        image_crop_info: _.get(eventDetail, 'image_crop_info', { x1: '0', x2: '0', y1: '0', y2: '0' }),
        eventDetailAdvSetStatus: getEventDetailAdvSetStatus(),
        tickets: _.size(tickets) ? tickets : [ defaultLevelObj() ],
        show_tickets: _.get(eventDetail, 'show_tickets', true),
        skip_event_landing_page: _.get(eventDetail, 'skip_event_landing_page', false),
        show_promotion_tickets: _.get(eventDetail, 'show_promotion_tickets', false),
        show_event_time_and_date: _.get(eventDetail, 'show_event_time_and_date', true),
        show_ticket_sales_time_count_down: _.get(eventDetail, 'show_ticket_sales_time_count_down', true),
        show_remaining_ticket_count:  _.get(eventDetail, 'show_remaining_ticket_count', false),
        skip_collect_attendee_information: _.get(eventDetail, 'skip_collect_attendee_information', true),
        need_collect_zip_code: _.get(eventDetail, 'need_collect_zip_code', true),
        need_collect_phone_number: _.get(eventDetail, 'need_collect_phone_number', true),
        is_set_tickets_total_capacity: _.get(eventDetail, 'is_set_tickets_total_capacity', false),
        tickets_total_capacity: _.get(eventDetail, 'tickets_total_capacity', 0),
        share_promotion_setting: eventDetail.share_promotion_setting || {
          according_to_value: 0,
          reward_item: 'Ticket',
          reward_value: 0,
          reward_ticket_id: _.get(eventDetail, 'tickets[0].id', ''),
          is_enabled: false
        },
        is_set_conversion_tracking_code: _.get(eventDetail, 'is_set_conversion_tracking_code', false),
        facebook_conversion_tracking_code: eventDetail.facebook_conversion_tracking_code || '',
        purchased_notification_emails: _.get(eventDetail, 'purchased_notification_emails', ''),
        sold_out_notification_emails: _.get(eventDetail, 'sold_out_notification_emails', ''),
        is_set_notification_email: _.get(eventDetail, 'is_set_notification_email', false),
        is_set_terms_and_conditions: _.get(eventDetail, 'is_set_terms_and_conditions', false),
        terms_and_conditions: _.get(eventDetail, 'terms_and_conditions', ''),
        is_set_confirm_email: _.get(eventDetail, 'is_set_confirm_email', false),
        confirmation_email_greeting: _.get(eventDetail, 'confirmation_email_greeting', ''),
        confirmation_email_support_email: _.get(eventDetail, 'confirmation_email_support_email', ''),
        confirmation_email_support_phone: _.get(eventDetail, 'confirmation_email_support_phone', ''),
        is_confirmation_email_include_tickets: _.get(eventDetail, 'is_confirmation_email_include_tickets', true),
        is_send_email_reminders: _.get(eventDetail, 'is_send_email_reminders', true),
        is_set_social_promotions: _.get(eventDetail, 'is_set_social_promotions', false),
        facebook_page: eventDetail.facebook_page || {
          title: '',
          imageUrl: '',
          description: '',
          share_url: '',
          share_url_way: 'EventUrl'
        },
        need_collect_demographic_data: _.get(eventDetail, 'need_collect_demographic_data', false),
        need_collect_full_birth_day: _.get(eventDetail, 'need_collect_full_birth_day', false),
        is_set_addtional_info: _.get(eventDetail, 'is_set_addtional_info', false),
        questions: !!eventDetail.questions ? _.map(eventDetail.questions, (i: {}): {} => ({
          ...i,
          applied_to_ticket_temp_id: i.applied_to_ticket_id
        })) : [],
        permission: _.get(eventDetail, 'permission', 'Write') || 'Write',
        isUrlNameHasBeenEdited: false
      };
    }

    componentDidMount() {
      ToggleLeftMenu('hide');

      if (this.isNew) {
        localStorage.setItem('initEventData', this.summaryEventData());
      }

      window.addEventListener('beforeunload', this.showWarningForLeavePage);
    }

    componentWillUnmount() {
      ToggleLeftMenu('show');

      localStorage.removeItem('initEventData');
      window.removeEventListener('beforeunload', this.showWarningForLeavePage);
    }

    showWarningForLeavePage = (): string => 'Don\'t leave';

    summaryEventData = (): string => {
      const data = {
        name: this.state.name,
        url: this.state.url_name,
        address: this.state.autoCompleteValue.formatted_address,
        timeZone: this.state.time_zone_id,
        begin_time_utc: this.state.begin_time_utc,
        end_time_utc: this.state.end_time_utc,
        long_description: this.state.long_description,
        imgUrl: this.state.imgUrl,
        skip_event_landing_page: this.state.skip_event_landing_page,
        show_event_time_and_date: this.state.show_event_time_and_date,
        show_tickets: this.state.show_tickets,
        show_promotion_tickets: this.state.show_promotion_tickets,
        show_ticket_sales_time_count_down: this.state.show_ticket_sales_time_count_down,
        show_remaining_ticket_count: this.state.show_remaining_ticket_count,
        skip_collect_attendee_information: this.state.skip_collect_attendee_information,
        need_collect_zip_code: this.state.need_collect_zip_code,
        need_collect_phone_number: this.state.need_collect_phone_number,
        is_set_tickets_total_capacity: this.state.is_set_tickets_total_capacity,
        tickets_total_capacity: this.state.tickets_total_capacity,
        tickets: this.state.tickets,
        need_collect_demographic_data: this.state.need_collect_demographic_data,
        need_collect_full_birth_day: this.state.need_collect_full_birth_day,
        is_set_addtional_info: this.state.is_set_addtional_info,
        questions: this.state.questions,
        is_set_donations: this.state.is_set_donations,
        donations: this.state.donations,
        is_set_social_promotions: this.state.is_set_social_promotions,
        facebook_page: this.state.facebook_page,
        is_set_confirm_email: this.state.is_set_confirm_email,
        confirmation_email_greeting: this.state.confirmation_email_greeting,
        confirmation_email_support_email: this.state.confirmation_email_support_email,
        confirmation_email_support_phone: this.state.confirmation_email_support_phone,
        is_confirmation_email_include_tickets: this.state.is_confirmation_email_include_tickets,
        is_send_email_reminders: this.state.is_send_email_reminders,
        is_set_terms_and_conditions: this.state.is_set_terms_and_conditions,
        terms_and_conditions: this.state.terms_and_conditions,
        is_set_notification_email: this.state.is_set_notification_email,
        purchased_notification_emails: this.state.purchased_notification_emails,
        sold_out_notification_emails: this.state.sold_out_notification_emails,
        is_set_conversion_tracking_code: this.state.is_set_conversion_tracking_code,
        facebook_conversion_tracking_code: this.state.facebook_conversion_tracking_code,
        share_promotion_setting: this.state.share_promotion_setting
      };

      return JSON.stringify(data);
    }

    handleLoaded = async (error: Error, { data }: any) => {
      let _tickets = _.get(data, 'result', defaultLevelObj());

      _tickets = _.map(_tickets, (t: {}): {} => {
        t.price = t.price / 100; // eslint-disable-line
        t.temp_id = t.id;  // eslint-disable-line

        return t;
      });

      if (!error) {
        this.setState({
          tickets: _tickets,
          current_inventory: _tickets.map((el: any): any => ({
            ...el.current_inventory,
            sold_quantity: el.stock_quantity - el.current_inventory.stock_quantity
          }))
        }, () => setTimeout(() => localStorage.setItem('initEventData', this.summaryEventData())), 0);
      }
    };

    controlTicketLevels = (tickets: []) => {
      this.setState({ tickets });
    };

    controlEventQuestion = (questions: []) => {
      this.setState({ questions });
    };

    controlEventDonations = (donations: []) => {
      this.setState({ donations });
    };

    handleControlDonationsEnabled= (status) => {
      this.setState({
        is_set_donations: status
      });
    };

    handleImageCropInfo = (image_crop_info: any) => {
      this.setState({ image_crop_info });
    }

    controlEventDemographic = (status, fullBitth) => {
      this.setState({
        need_collect_demographic_data: status,
        need_collect_full_birth_day: fullBitth
      });
    };

    controlEventAdditionalInfo = (status) => {
      this.setState({
        is_set_addtional_info: status
      });
    };

    controlEventTerms = (status) => {
      this.setState({
        is_set_terms_and_conditions: status
      });
    };

    controlSocialPromotions = (status) => {
      this.setState({
        is_set_social_promotions: status
      });
    };

    controlConversationTrackingCode = (status) => {
      this.setState({
        is_set_conversion_tracking_code: status
      });
    };

    controlNotificationEmail = (status) => {
      this.setState({
        is_set_notification_email: status
      });
    }

    handleControlFB = (key: string, value: any) => {
      this.setState({
        facebook_page: {
          ...this.state.facebook_page,
          [key]: value
        }
      });
    };

    handleControlEmailChecked = (status) => {
      this.setState({
        is_set_confirm_email: status
      });
    };

    handleControlGuestShare = (key: string, value: any) => {
      this.setState({
        share_promotion_setting: {
          reward_item: 'Ticket',
          according_to: 'TicketQuantity',
          ...this.state.share_promotion_setting,
          [key]: value
        }
      });
    };

    setOpenedCropModal = (status: boolean) => {
      this.setState({
        openedCropModal: status
      });
    };

    validateStartEndDate = (type: string, slaveDate: string): boolean => {
      document.querySelector('.dateValidationMsg').style.display = 'none';
      document.querySelector('.e_dateValidationMsg').style.display = 'none';

      const masterDate = type === 'begin_time_utc' ? this.state.end_time_utc : this.state.begin_time_utc;

      const mask = type === 'begin_time_utc' ?
        moment(masterDate).isAfter(slaveDate) :
        moment(masterDate).isBefore(slaveDate);

      const el = type === 'begin_time_utc' ?
        document.querySelector('.dateValidationMsg') :
        document.querySelector('.e_dateValidationMsg');

      if (!mask) {
        el.style.display = 'block';
      } else {
        el.style.display = 'none';
      }
    };

    handleChangeDate = (date: string, field: string) => {
      this.validateStartEndDate(field, date);
      this.setState({
        [field]: date
      });
    };

    handleSetImages = (name: string, file: File) => {
      this.setState({
        [name]: file
      });
    };

    setBaseImage = (data: {}) => {
      this.setState({
        baseImage: {
          file: data.file,
          image: data.image
        }
      });
    };

    handleSaveImg = async (file: any, callback: (string, string) => void): any => {
      if (file) {
        const formData = new FormData();

        formData.append('FileName', file);

        try {
          CssPinner(document.querySelector('.EventPicture'), true);
          const profileId = this.props.defaultContext.profileCurrent.id;

          const { result } = await POST(

            `/api/v1/1/assets/upload/${profileId}`,
            formData,
            null,
            'multipart/form-data');

          CssPinner(document.querySelector('.EventPicture'), false);

          return callback(
            _.get(result, '[0].url', null),
            `${process.env.IMAGE_CASH_URL}/${_.get(result, '[0].relative_url', null)}`
          );
        } catch (error) {
          CssPinner(document.querySelector('.EventPicture'), false);
          console.error(error);

          this.setOpenedCropModal(false);

          this.props.defaultContext.handleShowSystemDialog(true, {
            systemDialogType: 'error',
            systemDialogTitle: 'Error!',
            systemDialogContent: 'Image upload failed'
          });
        }
      }
    };

    setCroppedImage = async (data: {}) => {
      await this.handleSaveImg(data.file, (fileURL: string, fileURLrelative: string) => {
        this.setState({
          imgUrl: fileURLrelative
        });
      });
    };

    handleChangeCheckbox = (e: SyntheticEvent<HTMLInputElement>) => {
      const value = e.target.checked;
      const name = e.target.name;

      this.setState({
        [name]: value
      });
    };

    handleChangeInput = (e: SyntheticEvent<HTMLInputElement>) => {
      const isNewEvent = this.props.match.params.viewTab !== 'edit';
      const value = e.target.value;
      const name = e.target.name;
      const { isUrlNameHasBeenEdited } = this.state;

      if (name === 'url_name') {
        this.setState({
          isUrlNameHasBeenEdited: true
        });
      }
      // synchrony change url field with name field
      if (isNewEvent && !isUrlNameHasBeenEdited && (name === 'name')) {
        // process.env.EVENT_HOST +
        let url_name = value
          .replace(/( )/g, '-')
          .replace(/(\/)/g, '-')
          .replace(/(\.)/g, '-')
          .replace(/(\,)/g, '-');

        if (name === 'name' && url_name && _.size(url_name) > 0) {
          url_name = url_name.substr(0, 49);
        }

        this.setState({ url_name: this.urlNamePrefix + url_name });
      }

      if (name !== 'url_name') {
        this.setState({
          [name]: value
        });
      } else {
        this.setState({ url_name: this.urlNamePrefix + value });
      }
    };

    getTzStar = async (location): any => {
      const coords = `${location.lat()},${location.lng()}`;
      const response = await fetch(
        `https://maps.googleapis.com/maps/api/timezone/json?key=${process.env.GOOGLE_API_KEY}&location=${coords}&timestamp=${new Date().getTime() / 1000}`
      );
      const data = await response.json();

      return data;
  }

    getZoom = (place): any => {
    let zoom = 13;

    if (place.types) {
        if (place.types.indexOf('country') > -1) {
            zoom = 3;
        }
        if (place.types.indexOf('administrative_area_level_1') > -1) {
            zoom = 5;
        }
        if (place.types.indexOf('locality') > -1) {
            zoom = 9;
        }
        if (place.types.indexOf('sublocality') > -1) {
            zoom = 12;
        }
    }
    return zoom;
}

    handleChangeSearchInput = async (value: {}) => {
      const { geometry: { location } } = value;
      const tzStar = await this.getTzStar(location);
      const tz_id =  getWindowsTzId(tzStar.timeZoneId);

      this.setState({
        autoCompleteValue: {
          formatted_address: `${value.name}, ${value.vicinity}`
        },
        lat: location.lat(),
        lng: location.lng(),
        time_zone_id: tz_id,
        map_zoom: this.getZoom(value)
      });
    };

    handleChangeSearchInputValue = (value: string) => {
      this.setState({
        autoCompleteValue: {
          formatted_address: value
        }
      });
    };

    handleScrollIntoIncorrectView = (node: HTMLElement) => {
      if (!node) {
        return;
      }

      node.scrollIntoView({ block: 'center' });
    }

    setValidateDataLength = (el: string, isRemove?: number) => {
      let _data = [];

      if (!isRemove) {
        _data = _.uniq([
          ...this.state.invalidInputsLength,
          el
        ]);
      } else {
        const _cState = _.clone(this.state.invalidInputsLength);

        _data = _.remove(_cState, (i: string): boolean => i !== el);
      }

      this.setState({
        invalidInputsLength: _data
      });
    }

    updateTickets = (_tickets: any) => {
      const updated = _tickets.map((el: any): any => ({
        ...el,
        temp_id: el.id
      }));

      this.setState({
        tickets: updated
      });
    }

    trimText = (string: string, length: number): string => (
      string.length > length ? `${string.substring(0, length - 3)}...` : string
    )

    handleSave = async (
      isNew: boolean,
      profileCurrent: {},
      onHandleChangeStepNavBar: () => void,
      isClone: boolean,
      isEditNew: boolean
    ): any => {
      const data = _.clone(this.state);

      const isMainInfoValid = validateTicketMainInfo(data, this.handleScrollIntoIncorrectView);
      const isTicketValid = validateTicketLevels(data, this.handleScrollIntoIncorrectView);
      const isQuestionsValid = validateQuestionLevels(data.questions, this.handleScrollIntoIncorrectView);
      const isFbValid = validateFbInfo(data.facebook_page, this.handleScrollIntoIncorrectView);
      const isDonationsValid = validateDonations(data.donations, this.handleScrollIntoIncorrectView);
      const isUrlValid = data.url_name.substring(process.env.EVENT_HOST.length).length >= 5;
      const isCustomizeConfirmationValid = data.is_set_confirm_email ? validateConfirmEmail(data.confirmation_email_support_email, data.confirmation_email_support_phone, this.handleScrollIntoIncorrectView) : true;

      if (this.state.is_set_social_promotions && !isFbValid) {
        return this.props.defaultContext.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: 'Customize Facebook Post settings is not valid'
        });
      }

      if (!isMainInfoValid
        || !isTicketValid
        || !isDonationsValid
        || !isQuestionsValid
        || !isCustomizeConfirmationValid
        || !!_.size(data.invalidInputsLength)) {
        console.warn(
          'isMainInfoValid: ',
          isMainInfoValid,
          'isTicketValid: ',
          isTicketValid,
          'isDonationsValid',
          isDonationsValid,
          'isQuestionsValid: ',
          isQuestionsValid,
          'isCustomizeConfirmationValid: ',
          isCustomizeConfirmationValid,
          'data.invalidInputsLength: ',
          !!_.size(data.invalidInputsLength)
        );

        if (!!_.size(data.invalidInputsLength)) {
          this.handleScrollIntoIncorrectView(document.querySelector(`.${data.invalidInputsLength[0]}`));
        }
        return false;
      }

      if (!isUrlValid) {
        this.props.defaultContext.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: 'The field "Event page URL" must be a string with a minimum length of 5 and a maximum length of 128.'
        });

        return;
      }

      if (!data.eventDetailAdvSetStatus) {
        data.skip_event_landing_page = false;
        data.show_event_time_and_date = true;
        data.show_promotion_tickets = false;
        data.show_tickets = true;
        data.show_ticket_sales_time_count_down = true;
        data.show_remaining_ticket_count = false;
        data.skip_collect_attendee_information = true;
        data.need_collect_zip_code = true;
        data.need_collect_phone_number = true;
        data.is_set_tickets_total_capacity = false;
      }

      if (isClone) {
        data.clone_from_event_id = this.props.eventId;
      }

      if (!_.size(data.tickets_total_capacity.toString())) {
        data.tickets_total_capacity = '0';
        data.is_set_tickets_total_capacity = false;
      }

      data.default_currency = profileCurrent.currency || 'USD';
      data.facebook_page = this.state.facebook_page;
      data.long_description = convertTextLinksToTargetBlank(this.state.long_description);
      _.assignIn(data, { fee_setting: {} });

      data.fee_setting.currency = profileCurrent.currency || 'USD';
      data.fee_setting.transaction_percent = 0.029;
      data.fee_setting.transacton_fix_fee = 30;
      data.id = isNew ? 0 : this.props.eventId;
      data.image_crop_info = this.state.image_crop_info;
      data.image_url = this.state.imgUrl;
      data.is_clone = !!isClone;
      data.is_set_discounts = _.some(data.discounts, ['is_disabled', false]);
      data.location = this.state.autoCompleteValue.formatted_address;
      data.merchant_id = profileCurrent.id;
      data.region = '';
      const sharePromotionSetting = this.state.share_promotion_setting;

      _.assignIn(data, { share_promotion_setting: {} });

      data.share_promotion_setting = sharePromotionSetting;
      data.share_promotion_setting.according_to = isNew ? 'TicketQuantity' : sharePromotionSetting.according_to;
      data.share_promotion_setting.id = isNew ? 0 : this.props.eventId;
      data.discounts = isNew ? [] : this.context.eventDetail.discounts;
      data.splash_page = {
        id: isNew ? 0 : this.props.eventId,
        is_active: true,
        theme: isNew ? 'Light' : this.context.eventDetail.splash_page.theme
      };
      data.status = 'Open';
      data.type = 'Ticketing';
      data.schedules = [{
        // eslint-disable-next-line
        id: isNew ? 0 : _.get(_.find(this.context.eventDetail.schedules, (s: {}): {} => s.event_id.toString() === this.props.eventId.toString()), 'id', 0),
        begin_time_utc: convertToUTC(this.state.begin_time_utc, this.state.time_zone_id),
        end_time_utc: convertToUTC(this.state.end_time_utc, this.state.time_zone_id),
        begin_time_local: moment().utc().format(),
        end_time_local: moment().utc().format(),
        event_id: this.state.id
      }];
      data.show_event_date = true;

      _.map(data.tickets, (t: {}, ti: number) => {
        if (t.id <= 0) {
          t.id = 0; // eslint-disable-line
        }

        if (isClone && !(t.temp_id.toString().substring(0, 1) === '-')) {
          // eslint-disable-next-line
          t.temp_id = `-${t.id}`; // do not transform to number!!!
          t.id = 0;
        }

        data.placement_index = ti;

        if (!t.is_customize_ticket_quantity_options) {
          t.default_ticket_quantity = 0;
          t.order_min_quantity = 0;
          t.order_max_quantity = 10;
        }

        if (!t.is_customize_ticket_taxes_and_fees) {
          t.merchant_fee = 0;
          t.tax = 0;
          t.fee_type = 'ExcludeFee';
        }

        if (!t.is_set_sale_time) {
          t.sale_begin_time_utc = data.begin_time_utc;
          t.sale_end_time_utc = data.end_time_utc;
        }
      });

      _.map(data.questions, (q: {}, qi: number) => {
        if (isClone) {
          delete q.applied_to_ticket_id;
          q.applied_to_ticket_temp_id = q.applied_to_ticket_temp_id.map((qt: number): string => {
             if (qt.includes('-')) return qt;
             return `-${qt}`;
          });
          delete q.id;
        }
      });

      if (isClone) {
        data.share_promotion_setting.reward_ticket_id = _.get(data, 'tickets[0].temp_id', '');
      } else {
        data.share_promotion_setting.reward_ticket_id = isNew ? -1001 : sharePromotionSetting.reward_ticket_id;
      }

      if (isNew || !this.state.is_set_social_promotions) {
        // set title/desc/share_url_way for fbook post in new event or disabled Customize Facebook Post setting
        data.facebook_page = {
          ...this.state.facebook_page,
          share_url_way: 'EventUrl',
          title: this.trimText(this.state.name, 50),
          description: this.trimText(this.state.long_description.replace(/<[^>]*>?/gm, '').replace(/&nbsp;/g, ' '), 250)
        };
      }

      data.url_name = this.state.url_name.substring(this.urlNamePrefix.length);

      try {
        CssPinner(document.body, true);
        NProgressCustom(true);

        const url = '/api/v1/1/events';
        const _data = {
          ...this.state,
          ...data
        };

        const omitedKeys = ['baseImage', 'coverImg', 'croppedImage', 'imgUrl', 'sharePromotionSetting'];

        const { result } = isNew ?
          await POST(url, _.omit(_data, omitedKeys)) :
          await PUT(`${url}/${this.props.eventId}?is_app=true`, _.omit(_data, omitedKeys));

        CssPinner(document.body, false);
        NProgressCustom(false);

        this.props.defaultContext.handleShowSystemDialog(true, {
          systemDialogType: 'success',
          systemDialogTitle: 'Great!',
          systemDialogContent: 'Successfully saved'
        });

        if (isNew || isEditNew) {
          this.setState({
            successSave: true
          });

          setTimeout(() => {
            this.setState({
              successSave: false
            }, () => {
              this.props.defaultContext.handleShowSystemDialog(false);
              this.props.history.push(`/events/new/${result.id}/design`);
              onHandleChangeStepNavBar(2);
            });
          }, 4000);
        }

        if (!isNew) {
          console.info('Event successfully saved');

          await this.context.handleUpdateData();
        }

        this.setState({
          ...this.initEventData()
        });

        localStorage.setItem('initEventData', this.summaryEventData());
        return true; // for RouterPrompt
      } catch (e) {
        CssPinner(document.body, false);
        NProgressCustom(false);

        this.setState({
          successSave: false
        });

        console.error('Can\'t save event');

        this.props.defaultContext.handleShowSystemDialog(true, {
          systemDialogType: 'error',
          systemDialogTitle: 'Error!',
          systemDialogContent: <GetErrorValidation data={e.data} />
        });
      }
    };

    onConfettiComplete = () => {
      this.setState({
        successSave: false
      });
    };

    render(): React.Component {
      return (
        <WrappedComponent
          {...this.props}
          {...this.state}
          handleLoaded={this.handleLoaded}
          setOpenedCropModal={this.setOpenedCropModal}
          setImageCropInfo={this.handleImageCropInfo}
          handleChangeDate={this.handleChangeDate}
          handleSetImages={this.handleSetImages}
          setBaseImage={this.setBaseImage}
          setCroppedImage={this.setCroppedImage}
          handleChangeCheckbox={this.handleChangeCheckbox}
          handleChangeInput={this.handleChangeInput}
          handleChangeSearchInput={this.handleChangeSearchInput}
          handleChangeSearchInputValue={this.handleChangeSearchInputValue}
          handleControlTicketLevels={this.controlTicketLevels}
          handleControlEventQuestion={this.controlEventQuestion}
          handleControlEventDonations={this.controlEventDonations}
          handleControlDonationsEnabled={this.handleControlDonationsEnabled}
          handleControlFB={this.handleControlFB}
          handleControlEmailChecked={this.handleControlEmailChecked}
          handleControlSocialPromotions={this.controlSocialPromotions}
          handleControlGuestShare={this.handleControlGuestShare}
          handleControlEventDemographic={this.controlEventDemographic}
          handleControlEventAdditionalInfo={this.controlEventAdditionalInfo}
          handleControlConversationTrackingCode={this.controlConversationTrackingCode}
          handleControlNotificationEmail={this.controlNotificationEmail}
          handleControlEventTerms={this.controlEventTerms}
          handleSave={this.handleSave}
          setValidateDataLength={this.setValidateDataLength}
          summaryEventData={this.summaryEventData}
        />
      );
    }
  }

  const WithDefaultContext = (Component: React.Component): React.Component =>
    (props: {}): React.Component => (
      <DefaultContainerContext.Consumer>
        {(context: {}): React.Component => <Component defaultContext={context} {...props} />}
      </DefaultContainerContext.Consumer>
    )

  ;

  return WithDefaultContext(withRouter(WithEventContextClass));
};

export default WithEventContext;
